@if (canAccessItemDetails()) {
  <app-link-column [label]="label()" [routerLink]="routerLink()" [newTab]="newTab()"></app-link-column>
} @else {
  {{ label() }}
}
